export const selectItems = state => state.vans.items;

export const selectLoading = state => state.vans.loading;

export const selectError = state => state.vans.error;
